import React from "react";

//material ui
import { useTheme } from "@mui/styles";
import { Box, Typography, Divider } from "@mui/material";

const useStyles = (theme, mt) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: { xs: "297px", md: "325px", lg: "500px", xl: "530px" },
    height: { xs: "486px", md: "450px", lg: "600px", xl: "672px" },
    background: "linear-gradient(to bottom, #fff 0%, #fff 100%);",
    borderRadius: "47px",
    mb: { xs: "33px" },
    boxShadow: "0 10px 50px 0 rgba(0, 0, 0, 0.05)",
  },
  icons: {
    mt: { xs: "30px", lg: "45px", xl: "106px" },
    fontSize: { xs: "30px", md: "30px", lg: "40px" },
  },
  mainText: {
    fontSize: { xs: "20px", md: "17px", lg: "26px" },
    lineHeight: { xs: 1.3, md: 1.5 },
    width: { xs: "234px", md: "300px", lg: "406px" },
    fontFamily: theme.typography.montserrat.light,
    textAlign: "center",
    color: theme.palette.blue.main,
    mt: { xs: "11px", lg: "21px" },
    letterSpacing: { md: "1.25px" },
    fontWeight: "300",
  },
  span: {
    fontWeight: "bold",
  },
  divider: {
    width: { xs: "192px", md: "270px", lg: "400px" },
    height: "0.5px",
    backgroundColor: theme.palette.blue.main,
    mt: { xs: "16px", md: "25px", lg: "32.5px" },
  },
  secondaryText: {
    fontSize: { xs: "21px", md: "18px", lg: "24px" },
    lineHeight: { xs: "inherit", md: 1.5 },
    width: { xs: "268px", md: "280px", lg: "400px" },
    fontFamily: theme.typography.anaHeim.regular,
    textAlign: "center",
    color: theme.palette.blue.main,
    mt: mt,
  },
});

const Card = ({ icons, mainText, secondaryText, button, mt, mr }) => {
  const theme = useTheme();
  const classes = useStyles(theme, mt);
  return (
    <Box sx={{ ...classes.container, mr }}>
      <Typography sx={classes.icons}>{icons}</Typography>
      <Typography sx={classes.mainText}>{mainText}</Typography>
      <Divider sx={classes.divider} />

      <Typography sx={classes.secondaryText}>{secondaryText}</Typography>
      {button}
    </Box>
  );
};

export default Card;
